import React from 'react';
import { List } from 'semantic-ui-react'
import queries from '../../../../src/utils/queries';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

import TitDer from '../../../components/funcionales/titder';


const DetalleNivel1 = ({elemento,}) => {

  return (
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.empresa}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.creadaEn?elemento.creadaEn.substr(0, 10):''}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.creadaPor}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.programadas}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.reportadas}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.pendientes}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcRep}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta==='Hallazgos'?'':elemento.ideal}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ejecutadas}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcEjec}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vigentes}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vencidas}</td>
      <td className='center aligned' style={{padding: '0.2em'}}>
            <i className={elemento.bandera} style={{padding: '0.2em'}}></i>
      </td>
    </tr>  
  )
};

const Lista = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class GerTribo2 extends React.Component {
  state={lista: this.props.list}

  render(){
    const {lista} = this.state;
    return (
      <div>
        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
          <thead className=''>
            <tr className=''>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Empresa</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Ruta</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Creada en</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Creada por</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Programadas</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Reportada en sistema</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Pendientes de reporte</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>% Avance real</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>% Avance ideal</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Ejecutadas</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>% Ejecutado</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Vigentes</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Vencidas</th>
              <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}> </th>
              </tr>
          </thead>
          <Lista list={lista}/>
        </table>
        <p></p>
      </div>
    )
  }
};  
export default compose(

)(GerTribo2)
